<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="1">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="供应商" span="3">
      {{ head.supplier.name }}
    </el-descriptions-item>
    <el-descriptions-item label="关联单据" span="3">
      {{ head.relatedCustomizePurchaseOrderHead.orderNo }}
    </el-descriptions-item>

    <el-descriptions-item label="所选商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品信息"
          min-width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content" style="max-width: 300px">
                  <p>
                    商品名称：{{
                      scope.row.relatedCustomizePurchaseOrderItem
                        .relatedCustomizeOrderItem.commodityName
                    }}
                  </p>
                  <p class="fm-mt-5">
                    备注：
                    <span
                      v-fmtype="
                        scope.row.relatedCustomizePurchaseOrderItem
                          .relatedCustomizeOrderItem.remark
                          ? ''
                          : 'warning'
                      "
                      >{{
                        scope.row.relatedCustomizePurchaseOrderItem
                          .relatedCustomizeOrderItem.remark || "——"
                      }}</span
                    >
                  </p>
                </div>
                <div>
                  <p class="fm-line-2">
                    商品名称：{{
                      scope.row.relatedCustomizePurchaseOrderItem
                        .relatedCustomizeOrderItem.commodityName
                    }}
                  </p>
                  <p class="fm-line-2 fm-mt-5">
                    备注：
                    <span
                      v-fmtype="
                        scope.row.relatedCustomizePurchaseOrderItem
                          .relatedCustomizeOrderItem.remark
                          ? ''
                          : 'warning'
                      "
                      >{{
                        scope.row.relatedCustomizePurchaseOrderItem
                          .relatedCustomizeOrderItem.remark || "——"
                      }}</span
                    >
                  </p>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="相关图片"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.relatedCustomizePurchaseOrderItem
                  .relatedCustomizeOrderItem.fileList &&
                scope.row.relatedCustomizePurchaseOrderItem
                  .relatedCustomizeOrderItem.fileList.length > 0
              "
            >
              <el-image
                v-for="(item, index) in scope.row
                  .relatedCustomizePurchaseOrderItem.relatedCustomizeOrderItem
                  .fileList"
                :key="index"
                :style="{
                  width: '45px',
                  height: '45px',
                  'border-radius': '5px',
                  border: '1px solid var(--fm-border-color)',
                  'margin-left': '5px',
                }"
                fit="cover"
                :preview-src-list="
                  scope.row.relatedCustomizePurchaseOrderItem.relatedCustomizeOrderItem.fileList.map(
                    (d) => d.sysFile.prefix + d.sysFile.name
                  )
                "
                :src="item.sysFile.prefix + item.sysFile.name"
              ></el-image>
            </div>
            <div class="fm-center" v-else>
              <p v-fmtype="'warning'">暂未上传</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="入库数量"
          width="100"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.itemQuantity +
              scope.row.relatedCustomizePurchaseOrderItem
                .relatedCustomizeOrderItem.unit
            }}
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item
      label="入库数量"
      :span="3"
    >
      {{ head.totalInputQuantity }}
    </el-descriptions-item>
    <el-descriptions-item label="纸质单据" span="3">
      <OrderImageList
        :list="head.paperOrderImageList"
        name="纸质单据图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item
      label="流程信息"
      :span=" 3"
    >
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizeInputOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.head
        ? this.showOrderInfo.head
        : {};
    },
    itemList() {
      return this.showOrderInfo && this.showOrderInfo.itemList
        ? this.showOrderInfo.itemList
        : [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CustomizeInputOrder:NeedApproval",
        "Order:CustomizeInputOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeInputOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeInputOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.customizeInputOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CustomizeInputOrderInfo.vue